import clsx from 'clsx';
import * as React from 'react';
import { T } from '../../../../../Translations';
import { MenuItemContent } from '../menuItems';
import { observer } from 'mobx-react';

type LinkActionType = 'new-tab' | 'current-tab';

interface Props {
  menuItemContent: MenuItemContent;
  actionType: LinkActionType;
}

const ExternalMenuItem: React.FC<Props> = ({ menuItemContent, actionType }) => {
  return (
    <div className="border-b-px border-b-slate-foreground md:border-b-none mr-3p last:mr-0">
      <a
        href={menuItemContent.to}
        target={actionType === 'new-tab' ? '_blank' : ''}
        data-test-external-menu-item={menuItemContent.rel}
        className={clsx(
          'text-teal-600 lg:py-0 lg:px-0 lg:text-base lg:text-[#212121]',
          'border-b-2 border-solid border-teal-600 hover:text-teal-600',
          'block py-3.5 px-5 hover:border-b-2 hover:border-teal-600 lg:pb-2',
          'text-lg font-medium hover:pb-2 lg:border-transparent',
        )}
      >
        <T kind={menuItemContent.content} />
      </a>
    </div>
  );
};
export default observer(ExternalMenuItem);
